
import { db } from '@/lib/firebase';
import { collection, addDoc, serverTimestamp, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { useState, useEffect } from 'react';

export interface Transaction {
    id?: string;
    userId: string;
    userName?: string;
    type: 'DEPOSIT' | 'WITHDRAW' | 'SWAP' | 'TRADING_BUY' | 'TRADING_SELL' | 'STAKING' | 'ETF_BUY' | 'ETF_SELL' | 'BLOCK_DEAL' | 'P2P' | 'STAKING_JOIN' | 'STAKING_CANCEL';
    asset: string;
    amount: string | number;
    status: 'PENDING' | 'COMPLETED' | 'FAILED' | 'APPROVED' | 'REJECTED';
    timestamp: any;
    settled?: boolean;
    metadata?: any;
}

export const useTransactionManager = (userId?: string) => {
    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userId) {
            setLoading(false);
            return;
        }
        const q = query(
            collection(db, 'transactions'),
            where('userId', '==', userId),
            orderBy('timestamp', 'desc')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const txs = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })) as Transaction[];
            setTransactions(txs);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [userId]);

    const addTransaction = async (txData: Omit<Transaction, 'timestamp' | 'id'>) => {
        try {
            const docRef = await addDoc(collection(db, 'transactions'), {
                ...txData,
                timestamp: serverTimestamp(),
            });
            return docRef.id;
        } catch (error) {
            console.error("Error adding transaction: ", error);
            return null;
        }
    };

    return { transactions, loading, addTransaction };
};
